import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { CheckboxInput, Typography } from '@guildeducationinc/recess';
import ExpandMore from '@guildeducationinc/recess/icons/ExpandMoreIcon';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useDecision } from '@optimizely/react-sdk';
import { getRolesToDisplay, ROLE_MAPPING, RoleVariaions } from '@src/constants/featureFlags';
import { RefinementListChildFilter } from '../RefinementListChildFilter';
import {
	genericRolesRefinementListAttributeMapping,
	specificRolesRefinementListAttributeMapping,
} from '../RefinementListChildFilter/refinementListChildFilterHelpers';
import styles from './RefinementListFacetValueSet.module.scss';

interface Props {
	categoryLabel?: string;
	facet: RefinementListItem;
	filterCategory?: string;
	onChange: (value: string) => void;
	setSelectedChildrenFilterCount: (value: number) => void;
}

export const RefinementListFacetValueSet: React.FC<Props> = ({
	categoryLabel,
	facet,
	filterCategory,
	onChange,
	setSelectedChildrenFilterCount,
}) => {
	const [isExpanded, setIsExpanded] = useState(false);

	useEffect(() => {
		if (!facet.isRefined) {
			setIsExpanded(false);
		}
	}, [facet.isRefined]);

	const [rolesDecision] = useDecision(ROLE_MAPPING);
	const rolesAttributeMapping =
		getRolesToDisplay(rolesDecision) === RoleVariaions.GENERIC
			? Object.keys(genericRolesRefinementListAttributeMapping)
			: Object.keys(specificRolesRefinementListAttributeMapping);
	const nestedFilters = rolesDecision.enabled
		? rolesAttributeMapping
		: ['Business', 'Certificates & bootcamps', 'Healthcare', 'Technology'];

	const testId = facet.value.includes("'s")
		? facet.value.replace(' ', '-').replace("'", '')
		: facet.label;

	if (nestedFilters.includes(facet.value)) {
		return (
			<>
				<div className='flex flexItems--center' key={facet.value}>
					<CheckboxInput
						checked={facet.isRefined}
						data-testid={`${testId}-checkbox`}
						label={
							<Typography className={styles.label} variant='body1' weight='normal'>
								{`${categoryLabel || facet.label} (${facet.count})`}
								<ExpandMore
									aria-expanded={isExpanded}
									className={classNames({
										[styles.expandMore]: isExpanded && facet.isRefined,
									})}
									size={18}
								/>
							</Typography>
						}
						name={facet.value}
						onChange={() => {
							setIsExpanded(!isExpanded);
							onChange(facet.value);
						}}
					/>
				</div>
				{facet.isRefined &&
					nestedFilters.map(parentFilterName => {
						if (parentFilterName === facet.value) {
							return (
								<RefinementListChildFilter
									filterCategory={filterCategory}
									key={parentFilterName}
									parent={parentFilterName}
									setSelectedChildrenFilterCount={setSelectedChildrenFilterCount}
								/>
							);
						}
						return null;
					})}
			</>
		);
	} else
		return (
			<div className='flex flexItems--center' key={facet.value}>
				<CheckboxInput
					checked={facet.isRefined}
					data-testid={`${testId}-checkbox`}
					label={
						<Typography className='cursor--pointer' variant='body1' weight='normal'>
							{`${categoryLabel || facet.label} (${facet.count})`}
						</Typography>
					}
					name={facet.value}
					onChange={() => onChange(facet.value)}
				/>
			</div>
		);
};
